import React from "react"
import { ExclusiveChoiceDropdown, Button, IconInfo } from "dash-styled"
import { CollaboratorRole } from "../../../../../Models/API/CollaboratorModel"

const roleList: CollaboratorRole[] = [
    CollaboratorRole.ADMIN,
    CollaboratorRole.INSTRUCTOR,
    CollaboratorRole.MEMBER
]

interface Props {
    label: string
    value?: CollaboratorRole
    className?: string
    onChange: (value: CollaboratorRole) => void
    onViewPermissions?: () => void
}

export const CollaboratorRoleChooser: React.FC<Props> = ({
    label,
    value,
    className,
    onViewPermissions,
    onChange
}: Props) => {
    return (
        <div className={`flex items-end ${className ?? ""}`}>
            <ExclusiveChoiceDropdown
                label={label}
                choices={roleList}
                value={value}
                onClick={onChange}
                className="w-64 capitalize"
            />
            {onViewPermissions !== undefined && (
                <Button
                    variant="text"
                    color="gray"
                    onClick={onViewPermissions}
                    className="flex-grow-0 w-auto ml-2 mb-3"
                >
                    <IconInfo />
                </Button>
            )}
        </div>
    )
}
